/**
 * TEMPORARY dummy data for Story Map list + board UI.
 * Delete this entire file when wiring real API.
 */

export const DUMMY_STORY_MAPS = [
    {
        id: 'sm-1',
        projectId: '*',
        title: 'Untitled Story Map',
        journeysCount: 3,
        stepsCount: 8,
        releasesCount: 3,
        storiesCount: 4,
        authorName: 'John Singh',
        createdDate: '4th Aug 2025',
    },
    {
        id: 'sm-2',
        projectId: '*',
        title: 'Customer Onboarding Flow',
        journeysCount: 2,
        stepsCount: 4,
        releasesCount: 2,
        storiesCount: 2,
        authorName: 'Meet Dalsaniya',
        createdDate: '12th Jan 2026',
    },
    {
        id: 'sm-3',
        projectId: '*',
        title: 'Mobile App Release v2',
        journeysCount: 2,
        stepsCount: 3,
        releasesCount: 1,
        storiesCount: 1,
        authorName: 'John Singh',
        createdDate: '3rd Mar 2026',
    },
]

export const DUMMY_STORY_MAP_BOARDS = {
    'sm-1': {
        id: 'sm-1',
        title: 'Untitled Story Map',
        journeys: [
            {
                id: 'j-1',
                title: '1. One',
                steps: [
                    { id: 's-1-1', title: '1.1 One Step', hasDescription: true, attachmentsCount: 1, commentsCount: 2 },
                    { id: 's-1-2', title: '1.2 Untitled Step' },
                    { id: 's-1-3', title: '1.3 Untitled Step' },
                    { id: 's-1-4', title: '1.4 Untitled Step' },
                    { id: 's-1-5', title: '1.5 Untitled Step' },
                ],
            },
            {
                id: 'j-2',
                title: '2. Two',
                steps: [{ id: 's-2-1', title: '2.1 Untitled Step' }],
            },
            {
                id: 'j-3',
                title: '3. Untitled Journey',
                steps: [
                    { id: 's-3-1', title: '3.1 Untitled Step' },
                    { id: 's-3-2', title: '3.2 Untitled Step' },
                ],
            },
        ],
        releases: [
            {
                id: 'r-1',
                title: 'Release 1',
                dateRange: '15 Aug 2023 - 22 Aug 2023',
                stories: [
                    {
                        id: 'st-1',
                        title: 'Untitled Story',
                        stepId: 's-1-1',
                        commentsCount: 1,
                        likesCount: 2,
                    },
                    {
                        id: 'st-2',
                        title: 'Untitled Story',
                        stepId: 's-1-1',
                    },
                ],
            },
            {
                id: 'r-2',
                title: 'Release 1',
                dateRange: '15 Aug 2023 - 22 Aug 2023',
                stories: [
                    {
                        id: 'st-3',
                        title: 'Untitled Story',
                        stepId: 's-1-1',
                    },
                ],
            },
            {
                id: 'r-3',
                title: 'Release 1',
                dateRange: '15 Aug 2023 - 22 Aug 2023',
                stories: [
                    {
                        id: 'st-4',
                        title: 'Untitled Story',
                        stepId: 's-1-5',
                    },
                ],
            },
        ],
    },
    'sm-2': {
        id: 'sm-2',
        title: 'Customer Onboarding Flow',
        journeys: [
            {
                id: 'j-2-1',
                title: '1. Sign Up',
                steps: [
                    {
                        id: 's-2-1-1',
                        title: '1.1 Create account',
                        commentsCount: 3,
                        likesCount: 1,
                    },
                    { id: 's-2-1-2', title: '1.2 Verify email' },
                ],
            },
            {
                id: 'j-2-2',
                title: '2. First Use',
                steps: [
                    { id: 's-2-2-1', title: '2.1 Welcome tour' },
                    {
                        id: 's-2-2-2',
                        title: '2.2 Setup profile',
                        attachmentsCount: 2,
                        hasDescription: true,
                    },
                ],
            },
        ],
        releases: [
            {
                id: 'r-2-1',
                title: 'Release 1',
                dateRange: '1 Jan 2026 - 15 Jan 2026',
                stories: [
                    {
                        id: 'st-2-1',
                        title: 'Untitled Story',
                        stepId: 's-2-1-1',
                        commentsCount: 2,
                        likesCount: 1,
                    },
                ],
            },
            {
                id: 'r-2-2',
                title: 'Release 2',
                dateRange: '16 Jan 2026 - 31 Jan 2026',
                stories: [
                    {
                        id: 'st-2-2',
                        title: 'Untitled Story',
                        stepId: 's-2-2-1',
                        attachmentsCount: 1,
                    },
                ],
            },
        ],
    },
    'sm-3': {
        id: 'sm-3',
        title: 'Mobile App Release v2',
        journeys: [
            {
                id: 'j-3-1',
                title: '1. Core flow',
                steps: [
                    { id: 's-3-1-1', title: '1.1 Login' },
                    { id: 's-3-1-2', title: '1.2 Dashboard' },
                ],
            },
            {
                id: 'j-3-2',
                title: '2. Settings',
                steps: [{ id: 's-3-2-1', title: '2.1 Preferences' }],
            },
        ],
        releases: [
            {
                id: 'r-3-1',
                title: 'Release 1',
                dateRange: '1 Mar 2026 - 15 Mar 2026',
                stories: [
                    {
                        id: 'st-3-1',
                        title: 'Untitled Story',
                        stepId: 's-3-1-1',
                    },
                ],
            },
        ],
    },
}

export const getDummyStoryMapsForProject = (projectId) =>
    DUMMY_STORY_MAPS.filter(
        (item) => item.projectId === '*' || item.projectId === projectId
    )

export const getDummyStoryMapBoard = (storyMapId) => {
    const board = DUMMY_STORY_MAP_BOARDS[storyMapId]
    if (!board) return null
    return JSON.parse(JSON.stringify(board))
}

export const createUid = (prefix) =>
    `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
